var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.warning)?_c('p',{staticClass:"timer-pill",attrs:{"role":"timer","aria-live":"off"}},[_vm._v(" زمان باقی‌مانده: "),_c('b',[_vm._v(_vm._s(_vm.formatted))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }